<template>
  <div class="container-fluid">
    <ResultDocumentPage v-if="$route.params.type === DocumentTypes.DOCUMENT" :slug="$route.params.slug" />
    <ResultGroupDocumentPage
      v-else-if="$route.params.type === DocumentTypes.GROUP_DOCUMENT"
      :slug="$route.params.slug"
    />
  </div>
</template>

<script>
import ResultDocumentPage from '../components/ResultDocument/ResultDocumentPage'
import ResultGroupDocumentPage from '../components/ResultDocument/ResultGroupDocumentPage'
import { Authentication, DocumentTypes } from '@/constants/DoITConstant.js'
import { AuthenticateAction } from '@/store/modules/AuthenticateStore'
import { setCookie } from '@/helpers/CookieHelper'
import { logoutWithoutRedirect } from '@/services/authentication_service'
import { TEMP_TOKEN_EXPIRE_TIME, TEMP_TOKEN_MAX_AGE } from '@/config/config_project'

export default {
  name: 'DocumentResultView',
  components: {
    ResultDocumentPage,
    ResultGroupDocumentPage,
  },
  async created() {
    const token = this.$route.query.t
    if (token) {
      if (this.isAuthenticated)
        await logoutWithoutRedirect()

      const expires = new Date(Date.now() + TEMP_TOKEN_EXPIRE_TIME)

      setCookie(Authentication.ACCESS_TOKEN_HEADER, token, {
        'max-age': TEMP_TOKEN_MAX_AGE,
        'expires': expires,
      })
      const path = this.$route.path
      // this.$router.push(path)
      location.href = path
    }
  },
  mounted() {
    this.$store.dispatch(AuthenticateAction.LOAD_FROM_SERVER)
  },
  data() {
    return {
      DocumentTypes,
    }
  },
}
</script>
